import CourseCards from "./course-cards";
import {FILTER_SELECTED_EVENT} from "../constants/events";
import animejs from "animejs";
import {comprehensiveRange, debounce, rangesIntersection, toNumberRange} from "../helpers/utils";

export default class CoursesMenuSection {
    constructor($root) {
        this.$root = $root;
        this.$mobileHeader = this.$root.querySelector('.courses-menu-section-header-mobile');
        this.$mobileHeaderBody = this.$mobileHeader.querySelector('.course-card-body');
        this.$mobileHeaderActiveTitle = this.$mobileHeader.querySelector('.course-category-active-title');
        this.$body = this.$root.querySelector('.courses-menu-section-body');
        this.$inner = this.$root.querySelector('.courses-menu-section-body-inner');
        this.$courseCards = this.$inner.querySelectorAll('.course-card');

        this.courseCards = new CourseCards(this.$courseCards);
        this.categoryAge = $root.dataset.categoryAge.split(',');
        this.expanded = false;
        this.mobileHeaderBodyHeight = null;

        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$mobileHeader.addEventListener('click', () => {
            if (this.expanded) {
                this.collapse();
            } else {
                this.expand();
            }
        });

        this.$root.addEventListener(FILTER_SELECTED_EVENT, ({ detail }) => {
            this.setFilter(detail);

            if (window.matchMedia('(max-width: 600px)').matches) {
                this.collapse(false);
            } else {
                animejs({
                    targets: this.$courseCards,
                    delay: 5,
                    opacity: {
                        value: [0, 1],
                        duration: 250
                    },
                    scale: {
                        value: [0.9, 1],
                        duration: 200
                    },
                    easing: 'easeInOutCubic'
                });
            }
        });

        window.addEventListener('resize', debounce(() => {
            if (window.matchMedia('(min-width: 601px)').matches) {
                this.clearState();
            }
        }, 20));
    }

    clearState() {
        this.$mobileHeader.classList.remove('-no-animation');
        this.$mobileHeader.classList.remove('-active');
        this.$mobileHeader.classList.remove('-pointer-active');
        this.$mobileHeader.removeAttribute('style');
        this.$body.removeAttribute('style');
        this.$courseCards.forEach($card => $card.removeAttribute('style'));
    }

    expand() {
        this.expanded = true;
        this.mobileHeaderBodyHeight = this.$mobileHeaderBody.offsetHeight;
        this.$mobileHeader.classList.remove('-no-animation');
        this.$mobileHeader.classList.add('-active');
        this.$mobileHeader.classList.add('-pointer-active');
        const activeTitleHeight = this.$mobileHeaderActiveTitle.offsetHeight;

        animejs({
            targets: this.$mobileHeader,
            height: activeTitleHeight,
            duration: 250,
            easing: 'easeInOutCubic'
        });
        animejs({
            targets: this.$body,
            height: this.$inner.offsetHeight,
            duration: 250,
            easing: 'easeInOutCubic'
        });
        animejs({
            targets: this.$inner.querySelectorAll('.course-card:not(.-hidden)'),
            translateY: [150, 0],
            opacity: [0, 1],
            duration: 300,
            easing: 'easeInOutCubic',
            delay: animejs.stagger(100, { start: 50 })
        });
    }

    collapse(animate = true) {
        const mobileHeaderBodyHeight = this.mobileHeaderBodyHeight;
        this.mobileHeaderBodyHeight = null;
        this.expanded = false;
        this.$mobileHeader.classList.remove('-no-animation');

        if (!animate) {
            this.$mobileHeader.classList.add('-no-animation');
        }

        this.$mobileHeader.classList.remove('-pointer-active');

        if (mobileHeaderBodyHeight) {
            animejs({
                targets: this.$mobileHeader,
                height: mobileHeaderBodyHeight,
                duration: animate ? 250 : 0,
                easing: 'easeInOutCubic'
            });
        }
        animejs({
            targets: this.$courseCards,
            opacity: 0,
            duration: animate ? 250 : 0,
            easing: 'easeInOutCubic',
        });
        animejs({
            targets: this.$body,
            height: 0,
            duration: animate ? 250 : 0,
            easing: 'easeInOutCubic'
        });
        setTimeout(() => this.$mobileHeader.classList.remove('-active'), animate ? 150 : 0);
    }

    setFilter(category) {
        const categoryRange = toNumberRange(category);
        let hasIntersection = false;

        this.$courseCards.forEach(($card) => {
            const ranges = $card.dataset.age.split(',').map(id => toNumberRange(id));
            const range = comprehensiveRange(...ranges);

            if (category === 'all' || rangesIntersection(categoryRange, range)) {
                hasIntersection = true;
                $card.classList.remove('-hidden');
            } else {
                $card.classList.add('-hidden');
            }
        });

        if (category === 'all' || hasIntersection) {
            this.$root.classList.remove('-hidden');
        } else {
            this.$root.classList.add('-hidden');
        }
    }
}